var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2B2A29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25256 15.0509L14.2674 17.748L18.7474 16.9755C19.4933 16.8464 20.2585 16.8851 20.9876 17.0887C21.7167 17.2923 22.3912 17.6558 22.9623 18.1526M33.7874 29.2155L26.6971 34.2532C25.9359 34.794 25.0273 35.0887 24.0936 35.0977C23.1599 35.1067 22.2458 34.8295 21.4743 34.3035L9.25256 25.972",
    stroke: "#FFED00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6331 25.9194L33.616 29.348L25.8308 23.0622L22.9668 25.1445C22.4063 25.5515 21.7097 25.7251 21.0237 25.6287C20.3377 25.5324 19.7159 25.1736 19.2891 24.628C18.8646 24.0826 18.6678 23.3941 18.7398 22.7067C18.8118 22.0194 19.1471 21.3866 19.6754 20.9411L22.6582 18.4337C23.3653 17.8385 24.1853 17.3924 25.0691 17.1222C25.9529 16.8519 26.8821 16.7631 27.8011 16.8611L32.448 17.3594L38.6331 14.0154",
    stroke: "#FFED00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8308 23.0781C27.7051 24.7467 30.3611 23.8941 31.3485 22.5319",
    stroke: "#FFED00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 7.99951)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForClients);
export default __webpack_public_path__ + "static/media/forClients.5ff370d3af1b9f31059b30fb4af5b807.svg";
export { ForwardRef as ReactComponent };